import { z } from 'zod'
import { instantSchema } from '../validators/temporal.validator.js'
import { eventDocumentKindSchema } from '../enums/event-document-kind.enum.js'

/**
 * Browser-usable document location: signed private object URL or an external
 * https link. Not a raw storage key.
 */
const documentWireUrlSchema = z
  .string()
  .min(1)
  .max(8_000)
  .refine((v) => /^https?:\/\//.test(v), 'Document url must be an http(s) URL')

/** A file attached to an event (signed storage URL or an external source). */
export const eventDocumentDtoSchema = z.object({
  id: z.string().uuid(),
  eventId: z.string().uuid(),
  name: z.string(),
  kind: eventDocumentKindSchema,
  contentType: z.string(),
  sizeBytes: z.number().int().nonnegative().nullable(),
  url: documentWireUrlSchema,
  /** Present when the doc was imported from an external system (e.g. Social Tables). */
  externalKey: z.string().nullable(),
  /**
   * The name of the person who uploaded or linked it. Null when the app added it
   * itself (a signed contract), or it was added before this was recorded.
   */
  addedBy: z.string().nullable(),
  createdAt: instantSchema,
  updatedAt: instantSchema,
})

export type EventDocumentDto = z.infer<typeof eventDocumentDtoSchema>

export const eventDocumentListDtoSchema = z.object({
  documents: z.array(eventDocumentDtoSchema),
  total: z.number().int().nonnegative(),
})

export type EventDocumentListDto = z.infer<typeof eventDocumentListDtoSchema>
